import { TOKEN, USER_ID } from "../types";

const intialState = {
  ekycData: {},
};

const ekyc = (state = intialState, action) => {
  switch (action.type) {
     /* istanbul ignore next */            //using this to ignore istanbul
    case TOKEN:
      return {
        ...state,
        token: action.payload.token,
      };
    case USER_ID:
      return {
        ...state,
        user_id: action.payload
      }
    default:
      return state;
  }
};

export default ekyc;
